import { useToasts } from '@brunommsilva/react-foundations';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { TEST_IDS } from '../../config/test-ids';
import useDeleteCategory from '../../hooks/categories/use-delete-category';
import { Category } from '../../models/categories';

export interface Props {
  show: boolean;
  category?: Category;
  onDeleted: () => void;
  onClose: () => void;
}

function DeleteCategoryModal({ show, onDeleted, onClose, category }: Props) {
  const { t } = useTranslation();
  const { showToast } = useToasts();
  const {
    deleteCategory,
    isDeleting,
    wasDeletedWithSuccess,
    wasDeletedWithoutSuccess,
  } = useDeleteCategory();

  const handleDeleteCategory = () => {
    if (category) {
      deleteCategory(category.id);
    }
  };
  const handleClose = () => onClose();

  useEffect(() => {
    if (wasDeletedWithSuccess) {
      showToast({
        title: t('DELETE_CATEGORY_SUCCESS_TOAST.TITLE'),
        message: t('DELETE_CATEGORY_SUCCESS_TOAST.MESSAGE'),
      });
      onDeleted();
    }
    if (wasDeletedWithoutSuccess) {
      showToast({
        title: t('DELETE_CATEGORY_ERROR_TOAST.TITLE'),
        message: t('DELETE_CATEGORY_ERROR_TOAST.MESSAGE'),
        type: 'error',
      });
    }
  }, [wasDeletedWithSuccess, wasDeletedWithoutSuccess]);

  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogTitle>{t('DELETE_CATEGORY_MODAL.TITLE')}</DialogTitle>
      <DialogContent>
        {t('DELETE_CATEGORY_MODAL.DESCRIPTION', { name: category?.name })}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={isDeleting}
          color="primary"
          onClick={handleClose}
        >
          {t('DELETE_CATEGORY_MODAL.CLOSE')}
        </Button>
        <Button
          variant="contained"
          data-testid={TEST_IDS.categories.deleteConfirm}
          disabled={isDeleting}
          color="error"
          onClick={handleDeleteCategory}
        >
          {t('DELETE_CATEGORY_MODAL.CONFIRM')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteCategoryModal;
